export enum FcmActionType { 
    none, 
    WebView, 
    app, 
    open_url, 
    ServerAction, 
    close, 
    sync 
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/enums.model.ts